import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor() {}

  /**
   * Exemplo de uso: <br/>
   * <code>
   *   funcionalidadeHabilitada('999-issue.888-subissue.777-subsubissue')
   * </code>
   * @param codigoFuncionalidade caminho para obter funcionalidade no properties
   */
  funcionalidadeHabilitada(codigoFuncionalidade: string): boolean {
    const featureFlags = (environment as any).simcaq?.featureFlag;
    if (!featureFlags || !codigoFuncionalidade) return false;

    const parts = codigoFuncionalidade.split('.').filter(Boolean);

    let node: any = featureFlags;

    for (const part of parts) {
      if (
        node === null || //propriedade inexistente
        node === undefined || //propriedade inexistente
        typeof node !== 'object' || //naveguei erronemaente em uma propriedade nao indexavel
        !(part in node) //propriedade inexistente
      )
        return false;

      node = node[part];
    }

    return Boolean(node?.finalizada);
  }
}
